module.exports = __webpack_public_path__ + "static/img/widget-5.aea4d4c9.png";